import serviceRegistery from './serviceRegistery'
import {
    helpers
} from './helpers'

import _ from 'underscore'
export const jsonHelper = {
    data() {
        return {

        }
    },
    mixins: [helpers],
    methods: {
        createJson(key, value, result) {
            //console.log('   key and value ', key, value, result);
            let finalKey = key;
            if (typeof result == "undefined") {
                result = {};
            }
            let nextResult = result;
            if (/\[\d*\]/.test(key)) {

                let arrayKey = key.replace(/\[\d*\]/, '');
                let idx = key.match(/\d+/)[0];
                if (typeof result[arrayKey] == "undefined") {
                    result[arrayKey] = [];
                }

                if (typeof value != "undefined") {
                    result[arrayKey][idx] = value;
                } else {
                    if (typeof result[arrayKey][idx] == "undefined") {
                        result[arrayKey][idx] = {};
                    }
                    nextResult = result[arrayKey][idx];
                }
                finalKey = arrayKey;
            } else {
                if (typeof value != "undefined") {
                    result[key] = value;
                } else if (typeof result[key] == "undefined") {
                    result[key] = {};
                }
            }
            return {
                key: finalKey,
                result: nextResult
            };
        },
        createDotJson(key, value, result) {
            //console.log('   key and value ', key, value, result);
            if (value.constructor === [].constructor) {
                for (let i = 0; i < value.length; i++) {
                    if (value[i].constructor === {}.constructor) {
                        this.createDotJson(key + "[" + i + "]", value[i], result);
                    } else {
                        result['config.' + key] = value;
                    }
                }
                //result['config.' + key] = value;
            } else if (value.constructor === {}.constructor) {
                for (let objectKey in value) {
                    this.createDotJson(key + "." + objectKey, value[objectKey], result);
                }
            } else {
                result['config.' + key] = value;
            }
        },
        dotNotationJsonToObject(dotJson) {
            let result;
            for (let key in dotJson) {
                //console.log('next key is : ', key);
                let value = dotJson[key];
                let parts = key.split(".");
                let resultJson = {
                    result: result
                };
                for (let i = 0; i < parts.length; i++) {
                    let innerResult;
                    if (resultJson.result) {
                        innerResult = resultJson.result[resultJson.key] || resultJson.result;
                    }
                    if (i == parts.length - 1) {
                        // console.log('last key', parts[i]);
                        resultJson = this.createJson(parts[i], value, innerResult);
                    } else {

                        resultJson = this.createJson(parts[i], undefined, innerResult);
                    }
                    //console.log('result json', resultJson);
                    if (!result) {
                        result = resultJson.result;
                    }
                }
            }
            return result;
        },
        getSubbrandinfo(reqObject, successAction, errorAction) {
            let reqObj = {
                id: reqObject._id,
                includeConfig: true
            }
            serviceRegistery
                .makeCall({
                    url: this.$hostname + 'services/subbrand/get',
                    method: 'POST',
                    data: reqObj
                })
                .then(response => {
                    if (response && response.data) {
                        let subbrandConfigData = response.data.config
                        console.log(subbrandConfigData)

                        // Convert object data into dot notation data
                        let dotNotationData = this.objectToDotNotationJson(
                            subbrandConfigData
                        )
                        console.log('Dot Notation Data--->', dotNotationData)

                        // Add Subbrand Info to dot notation data
                        const subbrandData = Object.assign({},
                            dotNotationData,
                            reqObject
                        )

                        // Merge the dot notation data in tempalte data
                        let orgTemplateData = JSON.parse(
                            JSON.stringify(
                                this.$store.state.createSubbrandStore.orgCreateTemplateData
                            )
                        )
                        let mergedData = this.mergeDotNotationInTemlateData(
                            subbrandData,
                            orgTemplateData
                        )

                        console.log('Mearged Data---->', mergedData)
                        this.$store.state.createSubbrandStore.createTemplateData = mergedData

                        // Navigate to Edit screen.
                        successAction()
                        // this.$router.push({
                        //   name: 'editSubbrand',
                        //   params: {
                        //     backLink: this.$router.history.current.path,
                        //     backText: 'Back to Sub-brands List',
                        //     isDraft: publishedStatus === 7
                        //   }
                        // })
                    } else {
                        errorAction()
                        // console.log('No DATA')
                    }
                })
                .catch(error => {
                    this.showToastMessage('Sorry, a technical error has occurred! Please try again later.')
                })
        },
        getChannelInfo(reqObject, successAction, errorAction) {
            let reqObj = {
                id: reqObject._id,
                includeConfig: true
            }
            serviceRegistery
                .makeCall({
                    url: this.$hostname + 'services/channel/get',
                    method: 'POST',
                    data: reqObj
                })
                .then(response => {
                    if (response && response.data) {
                        let channelConfigData = response.data.config
                        console.log(channelConfigData);

                        // Convert object data into dot notation data
                        let dotNotationData = this.objectToDotNotationJson(
                            channelConfigData
                        )
                        console.log('Dot Notation Data--->', dotNotationData)

                        // Add Subbrand Info to dot notation data
                        const channelData = Object.assign({},
                            dotNotationData,
                            reqObject
                        )

                        // Merge the dot notation data in tempalte data
                        let orgTemplateData = JSON.parse(
                            JSON.stringify(
                                this.$store.state.channelStore.orgChannelFormData
                            )
                        )
                        let mergedData = this.mergeDotNotationInTemlateData(
                            channelData,
                            orgTemplateData
                        )

                        console.log('Mearged CHANNEL Data---->', mergedData)
                        this.$store.state.channelStore.channelFormData = mergedData
                        successAction()
                    } else {
                        errorAction()
                        // console.log('No DATA')
                    }
                })
                .catch(error => {
                    this.showToastMessage('Sorry, a technical error has occurred! Please try again later.')
                })
        },
        objectToDotNotationJson(jsonObj) {
            let result = {};
            for (let key in jsonObj) {
                this.createDotJson(key, jsonObj[key], result);
            }
            return result;
        },
        mergeDotNotationInTemlateData(dotJsonObj, templateData, channelDataMerge) {
            let configData = templateData.content;
            for (let dotObjkey in dotJsonObj) {
                for (let i = 0; i <= configData.length - 1; i++) {
                    if (configData[i] && configData[i].form) {
                        let formData = configData[i].form
                        for (let j = 0; j <= formData.length - 1; j++) {
                            if (formData[j].controlName === 'formGroup' || formData[j].controlName === 'productGroup') {
                                if (formData[j] && formData[j].key && dotObjkey == formData[j].key) {

                                    if (channelDataMerge) {
                                        if (dotJsonObj[dotObjkey]) {
                                            formData[j].show = true
                                            formData[j].defaultValue = true
                                        } else {
                                            formData[j].show = false
                                            formData[j].defaultValue = false
                                        }
                                    } else {
                                        formData[j].defaultValue = dotJsonObj[dotObjkey];
                                    }
                                }
                                let fromGroupData = formData[j].formData
                                for (let l = 0; l <= fromGroupData.length - 1; l++) {
                                    if (fromGroupData[l] && fromGroupData[l].key && dotObjkey == fromGroupData[l].key) {

                                        if (channelDataMerge) {
                                            if (dotJsonObj[dotObjkey]) {
                                                fromGroupData[l].show = true
                                                fromGroupData[l].defaultValue = true
                                            } else {
                                                fromGroupData[l].show = false
                                                fromGroupData[l].defaultValue = false
                                            }
                                            if (_.isString(dotJsonObj[dotObjkey]) ) {
                                                fromGroupData[l].defaultValue = dotJsonObj[dotObjkey]
                                            }
                                        } else {
                                            fromGroupData[l].defaultValue = dotJsonObj[dotObjkey];
                                        }
                                    }

                                    //matchinService
                                    let subFromGroupData = fromGroupData[l].formData
                                    if(subFromGroupData) {
                                        for (let k = 0; k <= subFromGroupData.length - 1; k++) {
                                            if (subFromGroupData[k] && subFromGroupData[k].key && dotObjkey == subFromGroupData[k].key) {
    
                                                if (channelDataMerge) {
                                                    if (dotJsonObj[dotObjkey]) {
                                                        subFromGroupData[k].show = true
                                                        subFromGroupData[k].defaultValue = true
                                                    } else {
                                                        subFromGroupData[k].show = false
                                                        subFromGroupData[k].defaultValue = false
                                                    }
                                                    if (_.isString(dotJsonObj[dotObjkey]) ) {
                                                        subFromGroupData[k].defaultValue = dotJsonObj[dotObjkey]
                                                    }
                                                } else {
                                                    subFromGroupData[k].defaultValue = dotJsonObj[dotObjkey];
                                                }
                                            }


                                            //cdv
                                            let childFromGroupData = subFromGroupData[k].formData
                                            if(childFromGroupData) {
                                                for (let m = 0; m <= childFromGroupData.length - 1; m++) {
                                                    if (childFromGroupData[m] && childFromGroupData[m].key && dotObjkey == childFromGroupData[m].key) {
    
                                                        if (channelDataMerge) {
                                                            if (dotJsonObj[dotObjkey]) {
                                                                childFromGroupData[m].show = true
                                                                childFromGroupData[m].defaultValue = true
                                                            } else {
                                                                childFromGroupData[m].show = false
                                                                childFromGroupData[m].defaultValue = false
                                                            }
                                                            if (_.isString(dotJsonObj[dotObjkey]) ) {
                                                                childFromGroupData[m].defaultValue = dotJsonObj[dotObjkey]
                                                            }
                                                        } else {
                                                            childFromGroupData[m].defaultValue = dotJsonObj[dotObjkey];
                                                        }
                                                    }
                                                }
                                            }

                                            
                                        }
                                    }
                                    // end
                                }
                            } else {
                                if (formData[j] && formData[j].key && dotObjkey == formData[j].key) {

                                    if (channelDataMerge) {
                                        if (_.isArray(dotJsonObj[dotObjkey])) {
                                            let opt = formData[j].options
                                            for (let k = 0; k <= opt.length - 1; k++) {
                                                if (dotJsonObj[dotObjkey].indexOf(opt[k].value) >= 0) {
                                                    opt[k].show = true
                                                    opt[k].defaultValue = true
                                                } else {
                                                    opt[k].show = false
                                                    opt[k].defaultValue = false
                                                }
                                            }
                                        }
                                    } else {
                                        formData[j].defaultValue = dotJsonObj[dotObjkey];
                                    }
                                }
                            }
                        }
                    }
                }

            }
            return templateData;
        }

    }
}